export default __webpack_public_path__ + "static/media/CryptoLogo.1548aced.png";